module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/landing-desktop-fondo.ca0ae1e4.jpg";